import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { ShoppingListItem, ShoppingListItemWithIngredient } from "../../shared/models/shopping-list-item";
import { QuotaInfo } from "../../shared/models/quota-info.model";

@Injectable({ providedIn: 'root' })
export class ShoppingListService {
  private static readonly BASE_URL = `${environment.apiUrl}/shopping-list`;

  constructor(private http: HttpClient) {}

  getShoppingListItems(): Observable<ShoppingListItemWithIngredient[]> {
    return this.http.get<ShoppingListItemWithIngredient[]>(ShoppingListService.BASE_URL);
  }

  getShoppingListQuota(): Observable<QuotaInfo> {
    return this.http.get<QuotaInfo>(`${ShoppingListService.BASE_URL}/quota`);
  }

  addShoppingListItem(
    shoppingListItem: Omit<ShoppingListItem, 'shopping_list_id'>
  ): Observable<ShoppingListItemWithIngredient> {
    return this.http.post<ShoppingListItemWithIngredient>(
      ShoppingListService.BASE_URL,
      shoppingListItem
    );
  }

  bulkAddShoppingListItems(
    items: Omit<ShoppingListItem, 'shopping_list_id' | 'household_id' | 'user_id'>[]
  ): Observable<ShoppingListItemWithIngredient[]> {
    return this.http.post<ShoppingListItemWithIngredient[]>(
      `${ShoppingListService.BASE_URL}/bulk-add`,
      items
    );
  }

  updateShoppingListItem(
    id: number,
    shoppingListItem: Partial<ShoppingListItem>
  ): Observable<ShoppingListItemWithIngredient> {
    return this.http.put<ShoppingListItemWithIngredient>(
      `${ShoppingListService.BASE_URL}/${id}`,
      shoppingListItem
    );
  }

  deleteShoppingListItem(id: number): Observable<void> {
    return this.http.delete<void>(`${ShoppingListService.BASE_URL}/${id}`);
  }

  clearBoughtItems(): Observable<void> {
    return this.http.delete<void>(`${ShoppingListService.BASE_URL}/bought`);
  }
}

